import { render, staticRenderFns } from "./EleFormGroup.vue?vue&type=template&id=51571c70&"
import script from "./EleFormGroup.vue?vue&type=script&lang=js&"
export * from "./EleFormGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports